module.exports = __webpack_public_path__ + "static/ptpro_logo-1c44774fec88f504540d1ad52691367f.png";